import PersonalTokensSettings from '@/pages/settings/personal-tokens';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/personal-tokens'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <PersonalTokensSettings />;
}
